import SectionHeading from '@/components/feature/SectionHeading';
import { rankBoard } from '@/mocks/library';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-600',
  down: 'ri-arrow-down-line text-foreground-500',
  flat: 'ri-subtract-line text-foreground-500',
};

const trendText: Record<string, string> = {
  up: '上升',
  down: '回落',
  flat: '持平',
};

export default function RankBoard() {
  return (
    <section id="rank" className="w-full bg-background-100 px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="热度榜"
            title="站内热度榜 TOP 10"
            description="按近期浏览热度排出的前十名，并标注相对上周的趋势。挑不出看什么的时候，从榜单前列开始通常不会踩空。"
          />
          <div className="mt-6 rounded-lg bg-foreground-950 p-4 md:p-5 text-background-100">
            <h3 className="font-heading text-sm md:text-base font-bold text-background-50 flex items-center gap-2">
              <i className="ri-award-line text-accent-400" aria-hidden="true"></i>
              榜单说明
            </h3>
            <p className="mt-3 text-xs md:text-sm leading-relaxed text-background-300">
              热度为站内整理口径，综合浏览、收藏与检索次数估算，用于帮助浏览，不代表任何官方数据或评价。趋势为与上一统计周期的对比。
            </p>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ol className="rounded-lg border border-background-200 overflow-hidden divide-y divide-background-200 bg-background-50">
            {rankBoard.map((item) => {
              const isTop = item.rank <= 3;
              return (
                <li key={item.id} className="flex items-center gap-3 md:gap-4 p-3 md:p-4 hover:bg-background-100 transition-colors">
                  <span
                    className={`w-8 h-8 md:w-9 md:h-9 shrink-0 rounded-md flex items-center justify-center font-heading text-sm md:text-base font-bold ${
                      isTop ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-800'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="text-sm md:text-base font-bold text-foreground-950 truncate">{item.title}</h3>
                    <p className="text-[11px] md:text-xs text-foreground-600 mt-1">{item.category}</p>
                  </div>
                  <div className="hidden sm:flex items-center gap-1 text-xs text-foreground-600 w-24">
                    <i className={trendIcon[item.trend]} aria-hidden="true"></i>
                    {trendText[item.trend]}
                  </div>
                  <div className="text-right shrink-0">
                    <p className="text-sm md:text-base font-bold text-foreground-950 whitespace-nowrap">{item.heat}</p>
                    <p className="text-[10px] md:text-[11px] text-foreground-500">热度</p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}